export const B_TYPE_360 = ['6x6', '6x5', '5x6', 'cup'];

export const isBType360 = (type360) => B_TYPE_360.includes(type360);

export const B_TYPE_RELATION4_CONFIRM =
  '360度診断Bタイプにおいて、部下（relation=4）が登録されようとしています。部下・同僚（relation=3）として登録しますか？';

export const convertBTypeRelation4Rows = (rows) =>
  (rows || []).map((row) =>
    row.relation === '4' ? { ...row, relation: '3' } : row
  );
